import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import { FolderOpen, UserPlus, Headphones } from 'lucide-react';

export default function EmployeeHome() {
  const { user, isAuthenticated } = useAuth();

  const formatSeniority = (days) => {
    if (!days) return '—';
    const y = Math.floor(days / 365);
    const d = days % 365;
    if (y > 0) return `${y} año${y > 1 ? 's' : ''} y ${d} día${d !== 1 ? 's' : ''}`;
    return `${d} día${d !== 1 ? 's' : ''}`;
  };

  return (
    <div className="main-content main-content--with-sidebar">
      <div className="page-content">
        {/* Welcome */}
        <div className="welcome-banner animate-in">
          <h2>
            {isAuthenticated
              ? `Hola, ${user.first_name}`
              : 'Bienvenido a SAEweb'}
          </h2>
          <p>Servicio de Atención al Empleado — Franquicia Miguel Ceínos</p>
        </div>

        {/* 3 Main Buttons */}
        <div className="main-buttons-grid">
          <Link to="/enlaces" className="main-button main-button--links animate-in">
            <div className="main-button__icon">
              <FolderOpen size={44} />
            </div>
            <div className="main-button__text">
              <h3>Repositorio de Enlaces</h3>
              <p>Accede a todas las herramientas y plataformas</p>
            </div>
          </Link>

          <Link to="/nuevo-empleado" className="main-button main-button--onboarding animate-in">
            <div className="main-button__icon">
              <UserPlus size={44} />
            </div>
            <div className="main-button__text">
              <h3>Nuevos Empleados</h3>
              <p>Alta, documentación y formación inicial</p>
            </div>
          </Link>

          <div className="main-button main-button--sae main-button--disabled animate-in">
            <div className="main-button__icon">
              <Headphones size={44} />
            </div>
            <div className="main-button__text">
              <h3>SAE</h3>
              <p>Servicio de Atención al Empleado</p>
              <span className="main-button__badge">Próximamente</span>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar – only when logged in */}
      {isAuthenticated && user && (
        <aside className="sidebar-panel">
          <div className="sidebar-panel__title">Mi Perfil</div>

          <div className="sidebar-panel__section">
            <div className="sidebar-panel__label">Restaurante</div>
            <div className="sidebar-panel__value">{user.restaurant_name || '—'}</div>
          </div>

          <div className="sidebar-panel__section">
            <div className="sidebar-panel__label">Categoría</div>
            <div className="sidebar-panel__value">{user.category_name || '—'}</div>
          </div>

          <div className="sidebar-panel__section">
            <div className="sidebar-panel__label">Fecha de inicio</div>
            <div className="sidebar-panel__value">
              {user.start_date
                ? new Date(user.start_date).toLocaleDateString('es-ES')
                : '—'}
            </div>
          </div>

          <div className="sidebar-panel__section">
            <div className="sidebar-panel__label">Antigüedad</div>
            <div className="sidebar-panel__value">{formatSeniority(user.seniority_days)}</div>
          </div>

          <div className="sidebar-panel__section">
            <div className="sidebar-panel__label">Código</div>
            <div className="sidebar-panel__value">{user.employee_code}</div>
          </div>

          {/* Pending courses */}
          <div className="sidebar-panel__title" style={{ marginTop: 16 }}>Cursos Pendientes</div>
          {(!user.pending_courses || user.pending_courses.length === 0) ? (
            <p style={{ fontSize: '0.85rem', color: 'var(--gray-400)' }}>No tienes cursos pendientes</p>
          ) : (
            user.pending_courses.map((c, i) => (
              <div key={i} className={`sidebar-course ${c.is_overdue ? 'sidebar-course--overdue' : ''}`}>
                <div className="sidebar-course__name">
                  {c.course_url ? (
                    <a href={c.course_url} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
                      {c.course_name}
                    </a>
                  ) : c.course_name}
                </div>
                <div className={`sidebar-course__deadline ${c.is_overdue ? 'sidebar-course__deadline--overdue' : ''}`}>
                  {c.is_overdue ? '⚠ Vencido · ' : 'Fecha límite: '}
                  {new Date(c.deadline).toLocaleDateString('es-ES')}
                </div>
              </div>
            ))
          )}

          {/* History */}
          {user.history && user.history.length > 0 && (
            <>
              <div className="sidebar-panel__title" style={{ marginTop: 16 }}>Historial</div>
              {user.history.map((h, i) => (
                <div key={i} className="sidebar-course" style={{ borderLeftColor: 'var(--gray-300)' }}>
                  <div className="sidebar-course__name">{h.restaurant_name || '—'}</div>
                  <div style={{ fontSize: '0.78rem', color: 'var(--gray-500)' }}>
                    {h.category_name || '—'} · {new Date(h.date_from).toLocaleDateString('es-ES')}
                    {h.date_to ? ` → ${new Date(h.date_to).toLocaleDateString('es-ES')}` : ' → actual'}
                  </div>
                </div>
              ))}
            </>
          )}
        </aside>
      )}
    </div>
  );
}
